import React from 'react';
import '../styles/Services.css';

const services = [
    {
        icon: 'fas fa-pencil-ruler',
        title: 'Dizainas',
        text: 'Tikime, kad geras dizainas – tai subtilios detalės ir aiškios linijos. Nesvarbu, ar ieškote modernaus, ar klasikinio stiliaus – sukursime sprendimą, kuris atitiks jūsų viziją.',
    },
    {
        icon: 'fas fa-tools',
        title: 'Gamyba',
        text: 'Baldų gamyboje deriname modernias technologijas su meistriškumu ir dėmesiu detalėms. Kiekvienas gaminys – tai kruopštus darbas, kokybė ir ilgaamžiškumas.',
    },
    {
        icon: 'fas fa-truck-loading',
        title: 'Montavimas',
        text: 'Pasirūpiname viskuo: baldų pristatymu, surinkimu ir galutiniu pritaikymu vietoje. Montavimą atliekame kruopščiai ir atsakingai.',
    },
];

const Services = () => {
    return (
        <section className="container section-services">
            <div className="row justify-content-between text-center">
                {services.map((service, index) => (
                    <div key={index} className="col-md-4 service-card">
                        <i className={`${service.icon} fa-3x mb-3 text-danger`}></i>
                        <h4>{service.title}</h4>
                        <p>{service.text}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Services;
